import type { AtendenteDTO, ConversaDetalheDTO } from '@viniko/shared';
import { useState } from 'react';
import { Modal, useToast } from '../../componentes/ui';
import { post } from '../../lib/api';
import { useAtendentes } from '../../lib/consultas';
import { useCorAtendente } from '../../lib/tema';

const ROTULO = { online: 'online', ausente: 'ausente', offline: 'offline' } as const;

export function ModalTransferir({
  conversa,
  eu,
  fechar,
}: {
  conversa: ConversaDetalheDTO;
  eu: AtendenteDTO;
  fechar: () => void;
}) {
  const toast = useToast();
  const lista = (useAtendentes().data ?? []).filter(
    (a) => a.ativo && a.id !== conversa.atendente?.id,
  );
  lista.sort(
    (a, b) =>
      ['online', 'ausente', 'offline'].indexOf(a.status) -
      ['online', 'ausente', 'offline'].indexOf(b.status),
  );
  const [destino, setDestino] = useState<string | null>(null);
  const [obs, setObs] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function transferir() {
    if (!destino) return;
    setEnviando(true);
    try {
      await post(`/api/conversas/${conversa.id}/transferir`, {
        atendenteId: destino,
        observacao: obs.trim() || undefined,
      });
      toast('Conversa transferida');
      fechar();
    } catch (e) {
      toast((e as Error).message, 'erro');
      setEnviando(false);
    }
  }

  return (
    <Modal titulo="Transferir conversa" aoFechar={fechar}>
      <div className="transferir-lista" role="radiogroup" aria-label="Atendente">
        {lista.map((a) => (
          <OpcaoAtendente
            key={a.id}
            a={a}
            eu={eu}
            marcado={destino === a.id}
            marcar={() => setDestino(a.id)}
          />
        ))}
      </div>
      <label className="campo">
        <span>Observação (opcional)</span>
        <textarea
          id="transferir-obs"
          className="input"
          rows={3}
          value={obs}
          onChange={(e) => setObs(e.target.value)}
          placeholder="Ex: cliente quer desconto, ver o frete"
        />
        <small>Fica no chat como observação: só a equipe vê.</small>
      </label>
      <div className="acoes">
        <button className="btn" onClick={fechar}>
          Cancelar
        </button>
        <button className="btn primario" disabled={!destino || enviando} onClick={transferir}>
          Transferir
        </button>
      </div>
    </Modal>
  );
}

function OpcaoAtendente({
  a,
  eu,
  marcado,
  marcar,
}: {
  a: AtendenteDTO;
  eu: AtendenteDTO;
  marcado: boolean;
  marcar: () => void;
}) {
  const cor = useCorAtendente(a.cor);
  return (
    <button role="radio" aria-checked={marcado} className="transferir-opcao" onClick={marcar}>
      <span
        className="avatar"
        style={{ width: 32, height: 32, fontSize: 12, background: cor.fundo, color: cor.texto }}
      >
        {a.nomeExibicao.slice(0, 2).toUpperCase()}
      </span>
      <span>
        <b>
          {a.nomeExibicao}
          {a.id === eu.id ? ' (você)' : ''}
        </b>
        <small>{a.nome}</small>
      </span>
      <span className={`status-txt st-${a.status}`}>{ROTULO[a.status]}</span>
    </button>
  );
}
